import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { fetchAppointmentView } from "slices/appointmentSlice";
import { useDispatch, useSelector } from "react-redux";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import toast from "react-hot-toast";
import { setActionAssign } from "slices/actionButtonSlice";
import CancelModal from "components/appointment/CancelModal";
import DonotCover from "components/appointment/DonotCover";
import AddVideoLink from "components/appointment/AddVideoLink";
import RescheduleModal from "components/appointment/RescheduleModal";
import { fetchAppointmentLogs } from "slices/appointmentSlice";
import LogsTable from "./LogsTable";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup } from "slices/appointmentSlice";
import { removeAppointment } from "slices/appointmentSlice";
import Swal from "sweetalert2";
import SelectInterpreterModal from "components/common/SelectInterpreterModal";
import CouldNotCover from "components/appointment/CouldNotCover";
import FullPageLoader from "components/common/FullPageLoader";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import { usePermissions } from "layouts/Admin";
import AddPatient from "components/appointment/AddPatient";
import ApprovalModal from "components/appointment/ApprovalModal";
import UpdateEmailConfirmationModal from "components/appointment/UpdateEmailConfirmationModal";
import { setIframeUrl } from "slices/iframeSlice";

// import moment from 'moment';
import DetailCard from "components/appointment/view/DetailCard";
import AppointmentViewHeader from "components/appointment/view/AppointmentViewHeader";
import ActionBar from "components/appointment/view/ActionBar";
import { appointmentRows, otherDetailRows, locationRows, requesterRows, vendorRows, requirementRows, dynamicFieldRows, checkInOutRows, customPricingRows, feedbackRows, videoRows } from "components/appointment/view/sections";
import moment from "moment-timezone";
import { Trash2, Video } from "lucide-react";
import Api from "services/api";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { CloseButton } from "reactstrap";
import { getCheckInStatus } from "slices/userSlice";
import { useTranslation } from "react-i18next";
const AppointmentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [donotCover, setDonotCover] = React.useState(false);
  const [addVideoLink, setAddVideoLink] = React.useState(false);
  const [addPatient, setAddPatient] = React.useState(false);
  const [couldNotCover, setCouldNotCover] = React.useState(false);
  const [approval, setApproval] = React.useState(false);
  const [assignInterpreter, setAssignInterpreter] = React.useState(false);
  const [rescheduleModal, setRescheduleModal] = React.useState(false);
  const [reassignEmailModalOpen, setReassignEmailModalOpen] = React.useState(false);
  const [reassignEmailPreviewHtml, setReassignEmailPreviewHtml] = React.useState('');
  const [reassignEmailPreviewSubject, setReassignEmailPreviewSubject] = React.useState('');
  const [reassignEmailPreviewButtonText, setReassignEmailPreviewButtonText] = React.useState('');
  const [reassignEmailPreviewRedirectLink, setReassignEmailPreviewRedirectLink] = React.useState('');
  const [reassignEmailAppointmentId, setReassignEmailAppointmentId] = React.useState(null);
  const [reassignEmailModalTitle, setReassignEmailModalTitle] = React.useState(() => t("appointmentView.reassignEmailTitle"));
  const [reassignEmailModalMessage, setReassignEmailModalMessage] = React.useState(() => t("appointmentView.reassignEmailMessage"));
  const [reassignEmailSendApi, setReassignEmailSendApi] = React.useState(() => Api.sendReassignEmail);
  const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
  const [removeVendorModal, setRemoveVendorModal] = React.useState(false);
  console.log('itemssssssss:', item);

  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);

  const location = useLocation();

  const callViewApi = async () => {
    const callBack = (success, message, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
        // console.log(data)
        if (data?.client_auto_assignment_notification_status === "pending") {
          handleOpenReassignEmailModal(
            id,
            data?.standard_email_html,
            data?.standard_email_subject,
            data?.standard_email_button_text,
            data?.standard_email_redirect_link,
            t("appointmentView.emailTitle"),
            t("appointmentView.assignmentEmailMessage"),
            Api.sendAutoAssignmentEmail
          );
        }
      } else {
        console.log(message);
      }
      // setItem()
    };

    dispatch(fetchAppointmentView(id, callBack));
  };

  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
        // console.log(data)
      } else {
        console.log(message);
      }
      // setLogs()
    };
    dispatch(fetchAppointmentLogs(id, callBack));
  };

  React.useEffect(() => {
    setLoading(true);
    callViewApi();
    fetchLogs();
  }, [id, location.key]);

  const handleCancel = () => {
    setCancelModal(true);
  };
  const handleCloseCancel = () => {
    setCancelModal(false);
  };
  const handleDonotCover = () => {
    setDonotCover(true);
  };
  const handleAddVideoLink = () => {
    setAddVideoLink(true);
  };
  const handleCloseDonotCover = () => {
    setDonotCover(false);
  };
  const handleCloseAddVideoLink = () => {
    setAddVideoLink(false);
  };

  const handleAddPatient = () => {
    setAddPatient(true);
  };
  const handleCloseAddPatient = () => {
    setAddPatient(false);
  };

  const handleApproval = () => {
    setApproval(true);
  };
  const handleCloseApproval = () => {
    setApproval(false);
  };

  const handleCouldNotCover = () => {
    setCouldNotCover(true);
  };
  const handleCloseCouldNotCover = () => {
    setCouldNotCover(false);
  };
  const handleReschedule = () => {
    setRescheduleModal(true);
  };
  const handleCloseReschedule = () => {
    setRescheduleModal(false);
  };
  const handleAssignInterpreter = () => {
    setAssignInterpreter(true);
  };
  const handleCloseAssignInterpreter = () => {
    setAssignInterpreter(false);
  };
  const handleOpenReassignEmailModal = (appointmentId, html, subject, buttonText, redirectLink, title, message, sendEmailApiFn) => {
    setReassignEmailAppointmentId(appointmentId);
    setReassignEmailPreviewHtml(html || '');
    setReassignEmailPreviewSubject(subject || 'Appointment Reassigned');
    setReassignEmailPreviewButtonText(buttonText || 'View Appointment');
    setReassignEmailPreviewRedirectLink(redirectLink || '');
    setReassignEmailModalTitle(title || t("appointmentView.reassignEmailTitle"));
    setReassignEmailModalMessage(message || t("appointmentView.reassignEmailMessage"));
    setReassignEmailSendApi(() => sendEmailApiFn || Api.sendReassignEmail);
    setReassignEmailModalOpen(true);
  };
  const handleCloseReassignEmailModal = () => {
    setReassignEmailModalOpen(false);
  };
  const handleReassignEmailComplete = () => {
    setReassignEmailModalOpen(false);
    callViewApi();
  };
  const handleOpenCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(true);
  };
  const handleCloseCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(false);
  };
  const handleEditAppointmentPopUp = () => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        popupType: "edit",
        item,
        callback: editFormSubmitCallback,
      })
    );
  };
  const handleCopyAppointmentPopUp = () => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        popupType: "copy",
        item,
      })
    );
  };
  const handleCloseEditApptPopup = () => {
    dispatch(closeAppointmentPopup());
  };

  const handleSubmit = (data, end_point, callBack) => {
    setLoading(true);
    const submitCallback = (success, message, responseData) => {
      callBack && callBack();
      if (success) {
        handleCloseCancel();
        handleCloseDonotCover();
        handleCloseAddVideoLink();
        handleCloseCouldNotCover();
        handleCloseReschedule();
        handleCloseAssignInterpreter();
        handleCloseEditApptPopup();
        handleCloseCheckinCheckoutModal();
        handleCloseAddPatient();
        handleCloseApproval();
        callViewApi();
        fetchLogs();
        toast.success(message, {
          className: "successToast",
        });
        if (end_point === 'reassign' && responseData?.data?.standard_email_html) {
          handleOpenReassignEmailModal(
            id,
            responseData.data.standard_email_html,
            responseData.data.standard_email_subject,
            responseData.data.standard_email_button_text,
            responseData.data.standard_email_redirect_link,
            t("appointmentView.reassignEmailTitle"),
            t("appointmentView.reassignEmailMessage"),
            Api.sendReassignEmail
          );
        }
        setLoading(false);
        // scheduleDetailModal?.show && openModal()
      } else {
        toast.error(message, {
          className: "errorToast",
        });
        setLoading(false);
      }
    };
    dispatch(setActionAssign(id, data, end_point, submitCallback));
  };

  const handleSendFeedbackMail = async () => {
    if (!item?.feedback) {
      toast.error(t("appointmentView.noFeedback"), {
        className: "errorToast",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await Api.setActionAssign(id, {}, 'feedback-mail');
      if (response?.status >= 200 && response?.status < 300) {
        toast.success(response?.data?.message || t("appointmentView.feedbackSent"), {
          className: "successToast",
        });
        callViewApi();
        fetchLogs();
      } else {
        toast.error(response?.data?.message || t("appointmentView.feedbackFailed"), {
          className: "errorToast",
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(t("appointmentView.feedbackFailed"), {
        className: "errorToast",
      });
    } finally {
      setLoading(false);
    }
  };

  const editFormSubmitCallback = () => {
    callViewApi();
  };

  const handleRemove = () => {
    const callBack = (success, message) => {
      if (success) {
        new Swal({
          title: message,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        navigate("/", { replace: true });
      } else {
        new Swal({
          title: message,
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    };
    new Swal({
      title: t("appointmentView.deleteConfirmTitle"),
      text: t("appointmentView.deleteConfirmText"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("appointmentView.deleteConfirmButton"),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeAppointment(id, callBack));
      }
    });
  };

  const navigateToInviteInterpreter = () => {
    // window.location.href = `/invite-interpreter/${id}`;
    navigate(`/appointments/invite-interpreter/${id}`);
  };
  const mileageCheck = (val) => {
    return item?.appointment_details?.[val];
  };

  const AppointmentTimezone = item?.appointment_details?.timezone;
  const rawDatetime = item?.datetime;

  // Date: use appointment timezone so late-night appointments don't shift the date
  const formattedDate = AppointmentTimezone?.name
    ? moment.tz(rawDatetime, AppointmentTimezone.name).format("MMM D, YYYY")
    : moment(rawDatetime).format("MMM D, YYYY");

  // Pacific time: parse stored datetime as appointment tz, then convert to Pacific
  const formattedDefaultTime = AppointmentTimezone?.name
    ? moment.tz(rawDatetime, AppointmentTimezone.name).tz("America/Los_Angeles").format("hh:mm A")
    : moment(rawDatetime).format("hh:mm A");

  // Appointment timezone time: parse as appointment tz and label it
  const formattedClientTime = (() => {
    if (!AppointmentTimezone?.name) return formattedDefaultTime;
    const m = moment.tz(rawDatetime, AppointmentTimezone.name);
    // const abbr = AppointmentTimezone.abbreviation;
    // const offset = AppointmentTimezone.utc_offset;
    // const zone = abbr ? `(${abbr} / GMT${offset})` : `(GMT${offset})`;
    const dynamicAbbr = m.format("z");
    const dynamicOffset = m.format("Z");
    
    const zone = dynamicAbbr ? `(${dynamicAbbr} / GMT${dynamicOffset})` : `(GMT${dynamicOffset})`;
    return `${m.format("hh:mm A")} ${zone}`;
  })();

  const [recordingUrl, setRecordingUrl] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);

  const [checkinStatus, setCheckinStatus] = useState(0);
  
    useEffect(() => {
      dispatch(
        getCheckInStatus((success, data) => {
          if (success) {
            setCheckinStatus(data?.data?.user?.checked_in);
          } else {
            console.log("Failed to fetch check-in status", data);
          }
        })
      );
    }, [dispatch]);
  
  //   Join Video Call handler
  const handleJoinVideoCall = async () => {
    if (checkinStatus !== 1) {
      toast.error(t("appointmentView.checkInFirst"), {
        className: "errorToast",
      });
      return;
    }

    if (
      item?.appointment_details?.video_platform === "external" &&
      item?.appointment_details?.video_link
    ) {
      window.open(item.appointment_details.video_link, "_blank");
      return;
    }

    try {
      const response = await Api.adminjoinVideoCall(id);
      if (response?.status === 200) {
        const iframeUrl = response?.data?.data?.iframe_url;
        dispatch(setIframeUrl(iframeUrl));
        navigate(`/appointments/view/join-room-call/${id}`);
        // console.log("Joined successfully:", response?.data?.data?.iframe_url);
        // console.log("Joined successfully:", response);
      } else {
        const errorMsg =
          response?.data?.statusText ||
          response?.data?.message ||
          response?.data?.error;
        console.error("Failed to join:", errorMsg);
        toast.error(errorMsg, { className: "errorToast" });
      }
    } catch (err) {
      console.error("Error joining video call:", err);
      toast.error(t("appointmentView.joinVideoError"), { className: "errorToast" });
    }
  };

  const showRecordingPopup = () => {
    if (item?.appointment_details?.recording) {
      setRecordingUrl(item.appointment_details.recording);
      setShowModal(true);
    } else {
      toast.error(t("appointmentView.recordingUnavailable"), {
        className: "errorToast",
      });
    }
  };

  const [inviteGuestPopup, setInviteGuestPopup] = React.useState({
    open: false,
    documents: [],
  });

  // Invites Guest Popup
  const InviteGuestPopup = ({ open, item, onClose, appointmentId }) => {
    const [loading, setLoading] = useState(false);
    const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({
      defaultValues: {
        emailArray: item?.appointment_details?.requester_email
          ? item.appointment_details.requester_email
              .split(",")
              .map((email) => ({ email: email.trim() }))
          : [{ email: "" }],
      },
    });

    const { fields, append, remove } = useFieldArray({
      control,
      name: "emailArray",
    });

    const onSubmit = async (data) => {
      const emails = data.emailArray
        .map((item) => item.email.trim())
        .filter(Boolean);
      // console.log("Emails to send:", emails);

      try {
        setLoading(true);
        const payload = { requester_email: emails };
        const response = await Api.inviteGuests(appointmentId, payload);
        console.log("res", response);
        toast.success(response?.data?.message);
        setLoading(false);
        setInviteGuestPopup({
          open: false,
          documents: [],
        });
        callViewApi();
      } catch (error) {
        setLoading(false);
        console.log("error", error);
      }
    };

    if (!open) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.3)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
          boxSizing: "border-box",
        }}
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            background: "#fff",
            borderRadius: 12,
            minWidth: 500,
            maxWidth: 900,
            width: "40%",
            maxHeight: "100%",
            padding: 32,
            boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
            position: "relative",
            overflowY: "auto",
          }}
        >
          <button
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              background: "none",
              border: "none",
              fontSize: 22,
              cursor: "pointer",
            }}
            onClick={onClose}
            aria-label="Close"
            type="button"
          >
            <CloseButton style={{ width: 10, height: 10 }} />
          </button>
          <h2 style={{ marginBottom: 24 }}>{t("appointmentView.inviteGuests")}</h2>

          {/* Render dynamic email inputs */}
          {fields.map((field, index) => (
            <div key={field.id} className="w-100 row-primary">
              <Controller
                name={`emailArray.${index}.email`}
                control={control}
                rules={{
                  required: t("appointmentView.emailRequired"),
                  pattern: {
                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                    message: t("appointmentView.invalidEmail"),
                  },
                }}
                defaultValue={field.email}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    {...field}
                    type="email"
                    placeholder={t("table.email")}
                    style={{ flexGrow: 1, marginRight: 8 }}
                  />
                )}
              />
              <button
                type="button"
                onClick={() => remove(index)}
                style={{
                  background: "red",
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  padding: "6px 14px",
                  cursor: "pointer",
                }}
              >
                <Trash2 style={{ width: 16, height: 16 }} />
              </button>
            </div>
          ))}

          {/* Show validation error for each email */}
          {errors.emailArray &&
            errors.emailArray.map((error, idx) =>
              error?.email ? (
                <div
                  key={idx}
                  style={{ color: "red", marginBottom: 10, fontSize: 12 }}
                >
                  {error.email.message}
                </div>
              ) : null
            )}

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <button
              type="button"
              onClick={() => append({ email: "" })}
              style={{
                padding: "10px 16px",
                borderRadius: 6,
                border: "1px solid #888",
                background: "white",
                cursor: "pointer",
              }}
            >
              {t("appointmentView.addEmail")}
            </button>

            <SubmitButton
              buttonType="submit"
              className={"button"}
              btnText={t("appointmentView.sendInvite")}
              disabled={loading}
              loader={loading}
            />
          </div>
        </form>
      </div>
    );
  };

  const notDone = item?.status !== "completed" && item?.status !== "cancelled";
  const isVri = item?.type === "Video Remote Interpretation";
  const dynamicRows = dynamicFieldRows(item, t);
  const pricingRows = item?.type !== "Telephonic" ? customPricingRows(item, t) : [];
  const vendor = vendorRows(item, t);

  const whenRows = [
    { label: t("table.date"), value: formattedDate },
    { label: t("appointmentView.appointmentTime"), value: formattedClientTime },
    { label: t("appointmentView.pacificTime"), value: formattedDefaultTime },
  ];

  return (
    <div className="content appt-view">
      {loading && <FullPageLoader />}

      <AppointmentViewHeader item={item} />

      <ActionBar
        right={
          <>
            {item?.appointment_details?.feedback_mail_sent === 0 && item?.feedback && item?.status === "completed" && (
              <SubmitButton buttonType="button" className="blue" btnText={t("appointmentView.sendFeedback")} handleSubmit={handleSendFeedbackMail} />
            )}
            {item?.appointment_details?.recording && (
              <SubmitButton buttonType="button" className="Cancle_button" btnText={t("appointmentView.viewRecording")} handleSubmit={showRecordingPopup} />
            )}
            {isVri && notDone && (
              <SubmitButton buttonType="button" className="Cancle_button" btnText={t("appointmentView.inviteGuests")} handleSubmit={() => setInviteGuestPopup({ open: true, documents: [] })} />
            )}
            {isVri && notDone && (item?.appointment_details?.video_platform === "algovi" || (item?.appointment_details?.video_platform === "external" && !!item?.appointment_details?.video_link)) && (
              <SubmitButton buttonType="button" className="green" btnText={t("appointmentView.joinVideoCall")} icon={<Video />} handleSubmit={handleJoinVideoCall} />
            )}
          </>
        }
      >
        {checkPermission("Copy Appointment") && (
          <SubmitButton buttonType="button" className="lightPurple" btnText={t("appointmentView.copy")} handleSubmit={handleCopyAppointmentPopUp} />
        )}
        {checkPermission("Assign Appointment") && notDone && (
          <SubmitButton buttonType="button" className="green" btnText={item?.status === "assigned" ? t("appointmentView.reassign") : t("appointmentView.assign")} handleSubmit={handleAssignInterpreter} />
        )}
        {checkPermission("Edit Appointments") && notDone && (
          <SubmitButton buttonType="button" className="lightGrey" btnText={t("vendors.edit")} handleSubmit={handleEditAppointmentPopUp} />
        )}
        {checkPermission("Reschedule Appointment") && notDone && (
          <SubmitButton buttonType="button" className="lightBlue" btnText={t("appointmentView.reschedule")} handleSubmit={handleReschedule} />
        )}
        {checkPermission("Donot Cover") && notDone && item?.status !== "dnc" && (
          <SubmitButton buttonType="button" className="yellow" btnText={t("appointmentView.doNotCover")} handleSubmit={handleDonotCover} />
        )}
        {checkPermission("Could Not Cover") && notDone && item?.status !== "cnc" && (
          <SubmitButton buttonType="button" className="yellow" btnText={t("appointmentView.couldNotCover")} handleSubmit={handleCouldNotCover} />
        )}
        {checkPermission("Cancel Appointment") && notDone && (
          <SubmitButton buttonType="button" className="tomatoRed" btnText={t("billing.cancel")} handleSubmit={handleCancel} />
        )}
        {checkPermission("Assign Appointment") && item?.status === "assigned" && item?.interpreter_id && (
          <SubmitButton buttonType="button" className="tomatoRed" btnText={t("appointmentView.removeVendor")} handleSubmit={() => setRemoveVendorModal(true)} />
        )}
        {checkPermission("Check-in/Check-out") && item?.status === "assigned" && !(isVri && item?.appointment_details?.video_platform === "external" && !item?.appointment_details?.video_link) && (
          <SubmitButton buttonType="button" className="Cancle_button" btnText={t("appointmentView.checkinCheckout")} handleSubmit={handleOpenCheckinCheckoutModal} />
        )}
        {checkPermission("Invite Interpreter") && item?.status === "available" && (
          <SubmitButton buttonType="button" className="green" btnText={t("appointmentView.inviteVendors")} handleSubmit={navigateToInviteInterpreter} />
        )}
        {checkPermission("Add Video Link") && notDone && isVri && item?.appointment_details?.video_platform === "external" && (
          <SubmitButton buttonType="button" className="primary" btnText={item?.appointment_details?.video_link ? t("appointmentView.editVideoLink") : t("appointmentView.addVideoLink")} handleSubmit={handleAddVideoLink} />
        )}
        {item?.type === "OPI On Demand" && item?.status !== "cancelled" && (
          <SubmitButton buttonType="button" btnText={t("addPatient.title")} handleSubmit={handleAddPatient} />
        )}
      </ActionBar>

      <div className="appt-grid">
        <div className="appt-col">
          <DetailCard title={t("appointmentView.cards.details")} rows={appointmentRows(item, t, { when: whenRows })} />
          <DetailCard title={t("appointmentView.cards.vendor")} rows={vendor} />
        </div>
        <div className="appt-col">
          <DetailCard title={t("appointmentView.cards.location")} rows={locationRows(item, t)} />
          <DetailCard title={t("appointmentView.cards.requester")} rows={requesterRows(item, t)} />
          <DetailCard title={t("appointmentView.cards.requirements")} rows={requirementRows(item, t)} />
        </div>
        <DetailCard className="appt-grid__full" title={t("appointmentView.cards.otherDetails")} columns={2} rows={otherDetailRows(item, t)} />
        {dynamicRows.length > 0 && (
          <DetailCard className="appt-grid__full" title={t("appointmentView.cards.customFields")} columns={2} rows={dynamicRows} />
        )}
        <DetailCard className="appt-grid__full" title={t("appointmentView.cards.checkInOut")} columns={2} rows={checkInOutRows(item, t)} />
        {isVri && <DetailCard title={t("appointmentView.cards.video")} rows={videoRows(item, t)} />}
        {pricingRows.length > 0 && (
          <DetailCard className="appt-grid__full" title={t("appointmentView.cards.pricing")} columns={2} rows={pricingRows} />
        )}
        {item?.status === "completed" && item?.feedback && (
          <DetailCard className="appt-grid__full" title={t("appointmentView.cards.feedback")} rows={feedbackRows(item, t)} />
        )}
      </div>

      <section className="appt-card appt-logs">
        <h3 className="appt-card__title">{t("appointmentView.logs")}</h3>
        <div className="appt-card__body">
          <LogsTable logs={logs} />
        </div>
      </section>

      <CancelModal
        isOpen={removeVendorModal}
        onClose={() => setRemoveVendorModal(false)}
        onConfirm={(data, endPoint) => handleSubmit(data, endPoint, () => setRemoveVendorModal(false))}
        appointmentId={id}
        item={item}
        loader={loading}
        end_point="remove-vendor"
        title={t("appointmentView.removeVendorTitle")}
        confirmText={t("appointmentView.removeVendor")}
      />

      <SelectInterpreterModal
        isOpen={assignInterpreter}
        onClose={handleCloseAssignInterpreter}
        onConfirm={handleSubmit}
        appointmentId={id}
        items={item}
        loader={loading}
        previewEmailOnSubmit={true}
        endpoint={item?.status === "assigned" ? "reassign" : "assign"}
      />

      <UpdateEmailConfirmationModal
        show={reassignEmailModalOpen}
        handleClose={handleCloseReassignEmailModal}
        appointmentId={reassignEmailAppointmentId}
        standardHtml={reassignEmailPreviewHtml}
        onComplete={handleReassignEmailComplete}
        // modalTitle="Send Appointment Reassign Email"
        // modalMessage="The appointment has been reassigned. Choose whether to send the standard client notification email, compose a custom client email, or skip client notification."
        modalTitle={reassignEmailModalTitle}
        modalMessage={reassignEmailModalMessage}
        sendEmailApi={reassignEmailSendApi}
      />

      <CancelModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <DonotCover
        isOpen={donotCover}
        onClose={handleCloseDonotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <AddVideoLink
        isOpen={addVideoLink}
        onClose={handleCloseAddVideoLink}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <AddPatient
        isOpen={addPatient}
        onClose={handleCloseAddPatient}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CouldNotCover
        isOpen={couldNotCover}
        onClose={handleCloseCouldNotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <RescheduleModal
        isOpen={rescheduleModal}
        onClose={handleCloseReschedule}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <CheckinCheckoutAdjustmentModal
        isOpen={checkinCheckoutModal}
        handleClose={handleCloseCheckinCheckoutModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        onSubmit={handleSubmit}
        item={item}
        loader={loading}
        targetTimezone={AppointmentTimezone?.name}
      />
      <ApprovalModal
        isOpen={approval}
        onClose={handleCloseApproval}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />

      <InviteGuestPopup
        appointmentId={id}
        open={inviteGuestPopup.open}
        item={item}
        onClose={() => setInviteGuestPopup({ open: false, documents: [] })}
      />
    </div>
  );
};

export default AppointmentView;
